/**
 * Query-string helpers for the results page (`/main-dashboard`).
 *
 * React Router v5 is in use — there is no `useSearchParams`, so callers build/parse the query
 * string themselves. Params: `q` (query) and `type` (SearchType). Keeping this pure makes the
 * shareable-URL contract unit-testable and shared between the header (writes it) and the results
 * page (reads it).
 */
import {SearchType} from './types'
import {coerceSearchType} from './utils'

export const RESULTS_PATH = '/main-dashboard'

/** Build a `?q=…&type=…` string for navigation. `all` and empty query are still encoded explicitly. */
export const buildResultsSearch = (query: string, type: SearchType): string => {
  const params = new URLSearchParams()
  const q = (query ?? '').trim()
  if (q) params.set('q', q)
  params.set('type', type)
  const s = params.toString()
  return s ? `?${s}` : ''
}

/** Parse a location.search string into { q, type }. Unknown/absent type falls back to 'all'. */
export const parseResultsSearch = (search: string): {q: string; type: SearchType} => {
  const params = new URLSearchParams(search || '')
  return {
    q: params.get('q') ?? '',
    type: coerceSearchType(params.get('type')),
  }
}
